import { render, staticRenderFns } from "./DisplayTrainingModuleSpotElement.vue?vue&type=template&id=42b47740&scoped=true&"
import script from "./DisplayTrainingModuleSpotElement.vue?vue&type=script&lang=ts&"
export * from "./DisplayTrainingModuleSpotElement.vue?vue&type=script&lang=ts&"
import style0 from "./DisplayTrainingModuleSpotElement.vue?vue&type=style&index=0&id=42b47740&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b47740",
  null
  
)

/* custom blocks */
import block0 from "./DisplayTrainingModuleSpotElement.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VCard,VCardText,VProgressCircular})
